module.exports = __webpack_public_path__ + "public/base/error/theme/default/images/error-500.png";


//////////////////
// WEBPACK FOOTER
// ./public/base/error/theme/default/images/error-500.png
// module id = 309
// module chunks = 0